const s = {
  name: "IndonesianRupiah",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22,31h2v-4h3c2.8,0,5-2.2,5-5s-2.2-5-5-5h-5V31z M27,25h-3v-6h3c1.7,0,3,1.3,3,3C30,23.7,28.7,25,27,25z"/>
		<path class="st0" d="M15,9h-5v18h2v-8h3c0.1,0,0.2,0,0.3,0l2.6,8H20l-2.8-8.5C18.9,17.7,20,16,20,14C20,11.2,17.8,9,15,9z M15,17
			h-3v-6h3c1.7,0,3,1.3,3,3S16.7,17,15,17z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as IndonesianRupiah
};
